const quizContent = {
  numops: {
    1: [
      {
        q: {
          title: "Count in order, forward and backward (0-50)",
          descriptors: [
            "Can they count forward starting at a random number between 0 and 50?",
            "Can they count backward starting at a random number between 0 and 50?",
          ],
        },
        ext: {
          title: "(Level 2) Count in order, forward and backward (0-100)",
          descriptors: [
            "Can they count forward starting at a random number between 50 and 100?",
            "Can they count backward starting at a random number between 50 and 100?",
          ],
        },
      },
      {
        q: {
          title:
            "Identify the largest and smallest 3 (or more) positive, whole quantities (0-10)",
          descriptors: [
            "Can they order three, nonsequential numbers between 0 and 10 from smallest to largest?",
          ],
        },
        ext: {
          title:
            "(Level 2) Identify more and less 3 (or more) positive, whole quantities (0-50)",
          descriptors: [
            "Can they compare two nonsequential numbers to determine which is more, less, or equal using numbers between 0 and 50?",
          ],
        },
      },
      {
        q: {
          title:
            "Represent a quantity from 0 to 10 with a matching numeral and word form",
          descriptors: [
            "Can they write a random number between 0 and 10 numerically and as its word form?",
          ],
        },
        ext: {
          title:
            "(Level 2) Round a number from 0 to 100 to the nearest tens' place",
          descriptors: [
            "Can they round a random number between 0 and 100 to the nearest tens' place?",
          ],
        },
      },
      {
        q: {
          title: "Identify a fair share (halves, thirds, and fourths)",
          descriptors: [
            "Given a shape with a line drawn through it, can they determine whether the two parts are fair or unfair shares?",
            "Given a shape that is cut (lines drawn) into thirds (precise or completely off), do they recognize whether the slices are fair shares?",
          ],
        },
        ext: {
          title:
            "(Level 2) Use a line to create a fair share (halves, thirds, and fourths)",
          descriptors: [
            "Given a shape, can they draw a line to cut it perfectly in half?",
          ],
        },
      },
      {
        q: {
          title: "Use counting strategies to add on and take away",
          descriptors: [
            "Can they count to add on or take away numbers between 0 and 10?",
          ],
        },
        ext: {
          title:
            "(Level 2) Use counting strategies to add and subtract double- and single-digit numbers?",
          descriptors: [
            "Can they do addition and subtraction with one, double-digit number and one, single-digit number?",
          ],
        },
      },
    ],
    2: [
      {
        q: {
          title: "Count in order, forward and backward (0-100)",
          descriptors: [
            "Can they count forward starting at a random number between 50 and 100?",
            "Can they count backward starting at a random number between 50 and 100?",
          ],
        },
        ext: {
          title: "(Level 3) Skip count by twos and fives up to 100",
          descriptors: ["Can they skip count by 2's, 5's, and 10's?"],
        },
      },
      {
        q: {
          title: "More and less 3+ positive whole quantities 0-50",
          descriptors: [
            "Can they compare two nonsequential numbers to determine which is more, less, or equal using numbers between 0 and 50?",
          ],
        },
        ext: {
          title:
            "(Level 3) Fractions on a number line and positive numbers with inequality symbols",
          descriptors: [
            "Can they compare two nonsequential whole numbers between -100 and 1000 using <, >, or = signs?",
          ],
        },
      },
      {
        q: {
          title: "Rounding to the nearest 10 (0-100)",
          descriptors: [
            "Can they round a random number between 0 and 100 to the nearest 10s place?",
          ],
        },
        ext: {
          title:
            "(Level 3) Rounding to the nearest 10 or 100 (ask about place value)",
          descriptors: [
            "Can they round a random number between 0 and 1000 to the nearest 100s place?",
          ],
        },
      },
      {
        q: {
          title: "Visual fractions (student draws line) half, third, fourth",
          descriptors: [
            "Given a shape, can they draw a line to cut it perfectly in half?",
            "Given a shape, can they draw lines to cut it perfectly into thirds?",
          ],
        },
        ext: {
          title: "(Level 3) Numerator and Denominator (proper fractions)",
          descriptors: [
            "\u2022 Can they write a fraction to represent the given fraction model?",
            "Can they identify the numerator and the denominator of a fraction given a fraction model?",
          ],
        },
      },
      {
        q: {
          title:
            "Double digit and single digit numbers (plus, minus, equals) using counting up strategies.",
          descriptors: [
            "Can they do addition and subtraction with one double digit number and one single digit number?",
          ],
        },
        ext: {
          title:
            "(Level 3) Three or more double digit numbers and addition and subtraction in the same equation. Showing the ability to regroup with one place value only.",
          descriptors: [
            "Can they perform addition and subtraction in the same equation using three or more double digit numbers?",
          ],
        },
      },
      {
        q: {
          title: "Adding equal groups of numbers (arrays and skip counting)",
          descriptors: ["Can they add equal groups of numbers?"],
        },
        ext: {
          title: "(Level 3) Multiply and divide two positive whole numbers",
          descriptors: [
            "Can they multiply and divide two positive whole numbers?",
          ],
        },
      },
    ],
    3: [
      {
        q: {
          title: "Skip by twos and fives up to 100.",
          descriptors: ["Can they skip count by 2's, 5's, and 10's?"],
        },
        ext: {
          title: "(Level 4) Matching negative numbers -1 to -100",
          descriptors: [
            "Can they place negative numbers between -1 and -100 on a number line?",
          ],
        },
      },
      {
        q: {
          title:
            "Fractions on a number line and positive numbers with inequality symbols",
          descriptors: [
            "Can they compare two nonsequential whole numbers between -100 and 1000 using <, >, or = signs?",
          ],
        },
        ext: {
          title:
            "(Level 4) Decimals on the number line and negative numbers using inequalities for both and fractions",
          descriptors: [
            "Can they compare two nonsequential decimals or fractions and using <, >, and = signs?",
          ],
        },
      },
      {
        q: {
          title: "Rounding to the nearest 10 or 100 (ask about place value)",
          descriptors: [
            "Can they round a random number between 0 and 1000 to the nearest 100s place?",
          ],
        },
        ext: {
          title: "(Level 4) Rounding to any place (ask about place value)",
          descriptors: [
            "Can they represent a number that is greater than 1,000 with base-ten blocks?",
          ],
        },
      },
      {
        q: {
          title: "Numerator and Denominator (proper fractions)",
          descriptors: [
            "Can they write a fraction to represent the given fraction model?",
            "Can they identify the numerator and the denominator of a fraction given a fraction model?",
          ],
        },
        ext: {
          title: "(Level 4) Reducing/Simplifying fractions",
          descriptors: ["Can they simplify a fraction?"],
        },
      },
      {
        q: {
          title:
            "Three or more double digit numbers and addition and subtraction in the same equation. Showing the ability to regroup with one place value only.",
          descriptors: [
            "Can they perform addition and subtraction in the same equation using three or more double digit numbers?",
          ],
        },
        ext: {
          title:
            "Positive and negative numbers, fractions with different denominators.",
          descriptors: [
            "Can they perform addition and subtraction with single digit negative numbers?",
            "Can they perform addition and subtraction with fractions that have different denominators?",
          ],
        },
      },
      {
        q: {
          title: "Multiply and divide two positive whole numbers",
          descriptors: [
            "Can they multiply and divide two positive whole numbers?",
          ],
        },
        ext: {
          title:
            "(Level 4) Multiply and divide in the same equation including triple digit by single digit division with remainders.",
          descriptors: [
            "Can they perform multiplication and division in the same equation?",
            "Can they perform a division equation that includes a triple digit number divided by a single digit number and yields a remainder?",
          ],
        },
      },
    ],
    4: [
      {
        q: {
          title: "Matching negative numbers -1 to -100",
          descriptors: [
            "Can they place negative numbers between -1 and -100 on a number line?",
          ],
        },
        ext: {
          title: "(Level 5) Matching all numbers no limit",
          descriptors: [
            "Can they place negative numbers outside of -1 and -100 on a number line?",
          ],
        },
      },
      {
        q: {
          title:
            "Decimals on the number line and negative numbers using inequalities for both and fractions",
          descriptors: [
            "Can they compare two nonsequential decimals or fractions and using <, >, and = signs?",
          ],
        },
        ext: {
          title:
            "(Level 5) Solving an inequality with variable (ties to algebra)",
          descriptors: [
            "Can they determine how many values are possible for x within a compound inequality comparing negative and positive whole numbers?",
          ],
        },
      },
      {
        q: {
          title: "Rounding to any place (ask about place value)",
          descriptors: [
            "Can they represent a number that is greater than 1,000 with base-ten blocks?",
          ],
        },
        ext: {
          title:
            "(Level 5) Rounding decimals to any place (ask about place value)",
          descriptors: [
            "Can they represent a decimal within a large quantity using base ten blocks and a blank fraction model?",
          ],
        },
      },
      {
        q: {
          title: "Reducing/Simplifying fractions",
          descriptors: ["Can they simplify a fraction?"],
        },
        ext: {
          title:
            "(Level 5) Converting between fractions, decimals, and percentages",
          descriptors: [
            "Can they convert a between fractions, decimals, and percentages?",
          ],
        },
      },
      {
        q: {
          title:
            "Positive and negative numbers, fractions with different denominators.",
          descriptors: [
            "Can they perform addition and subtraction with single digit negative numbers?",
            "Can they perform addition and subtraction with fractions that have different denominators?",
          ],
        },
        ext: {
          title:
            "(Level 5) Double digit positive and negative numbers, mixed numbers with different denominators.",
          descriptors: [
            "Can they perform addition and subtraction with double digit negative numbers?",
            "Can they perform addition and subtraction with mixed numbers that have different denominators?",
          ],
        },
      },
      {
        q: {
          title:
            "Multiply and divide in the same equation including triple digit by single digit division with remainders.",
          descriptors: [
            "Can they perform multiplication and division in the same equation?",
            "Can they perform a division equation that includes a triple digit number divided by a single digit number and yields a remainder?",
          ],
        },
        ext: {
          title: "(Level 5) Divide with decimals",
          descriptors: ["Can they perform division using decimals?"],
        },
      },
    ],
    5: [
      {
        q: {
          title: "Matching all numbers no limit",
          descriptors: [
            "Can they place negative numbers outside of -1 and -100 on a number line?",
          ],
        },
      },
      {
        q: {
          title: "Solving an inequality with variable (ties to algebra)",
          descriptors: [
            "Can they determine how many values are possible for x within a compound inequality comparing negative and positive whole numbers?",
          ],
        },
      },
      {
        q: {
          title: "Rounding decimals to any place (ask about place value)",
          descriptors: [
            "Can they represent a decimal within a large quantity using base ten blocks and a blank fraction model?",
          ],
        },
      },
      {
        q: {
          title: "Converting between fractions, decimals, and percentages",
          descriptors: [
            "Can they convert a between fractions, decimals, and percentages?",
          ],
        },
      },
      {
        q: {
          title:
            "Double digit positive and negative numbers, mixed numbers with different denominators.",
          descriptors: [
            "Can they perform addition and subtraction with double digit negative numbers?",
            "Can they perform addition and subtraction with mixed numbers that have different denominators?",
          ],
        },
      },
      {
        q: {
          title: "Divide with decimals",
          descriptors: ["Can they perform division using decimals?"],
        },
      },
    ],
  },
  algebra: {
    1: [
      {
        q: {
          title:
            "Solve informal addition and subtraction with an unknown number",
          descriptors: [
            "Can they find the missing amount to produce a given quantity of objects using additive thinking?",
            "Can they find the missing amount to produce a given quantity of objects using subtractive thinking?",
          ],
        },
        ext: {
          title:
            "(Level 2) Solve one-step addition and subtraction equations, with a symbol representing an unknown number",
          descriptors: [
            "Can they find the missing amount to produce a given quantity of numbers using addition?",
            "Can they find the missing amount to produce a given quantity of numbers using subtraction?",
          ],
        },
      },
      {
        q: {
          title: "Identify and complete repeating patterns",
          descriptors: ["Can they continue a repeating, one-variable pattern?"],
        },
        ext: {
          title: "(Level 2) Identify and complete growing patterns",
          descriptors: ["Can they continue a two-variable, growing pattern?"],
        },
      },
      {
        q: {
          title: "Find objects that match a given criteria",
          descriptors: [
            "Given a set of objects, can they pick out all of the objects that are a specific shape or color?",
          ],
        },
        ext: {
          title: "(Level 2) Name a criteria of pre-determined group",
          descriptors: [
            "Given a few sets of objects already organized into groups, can they identify what each group represents (i.e. all of these are green, all of these are round)?",
          ],
        },
      },
    ],
    2: [
      {
        q: {
          title:
            "Solve one-step addition and subtraction equations, with a symbol representing an unknown number",
          descriptors: [
            "Can they find the missing amount to produce a given quantity of numbers using addition?",
            "Can they find the missing amount to produce a given quantity of numbers using subtraction?",
          ],
        },
        ext: {
          title:
            "(Level 3) Solve equations that use variables to represent unknown numbers",
          descriptors: [
            "Can they use their understanding of operations to solve situations where they are multiple unknowns?",
          ],
        },
      },
      {
        q: {
          title: "Identify and complete growing patterns",
          descriptors: ["Can they continue a two-variable, growing pattern?"],
        },
        ext: {
          title: "(Level 3) Identify and complete a pattern of rotation",
          descriptors: ["Can they explain and continue a pattern of rotation?"],
        },
      },
      {
        q: {
          title: "Name a criteria for a pre-determined group",
          descriptors: [
            "Given a few sets of objects already organized, can they identify what each group represents (i.e. all of these are green, all of these are round)?",
          ],
        },
        ext: {
          title: "(Level 3) Make a key to classify 2D shapes",
          descriptors: [
            "Can they explain 3 different ways to classify the same group 2D shapes?",
          ],
        },
      },
    ],
    3: [
      {
        q: {
          title:
            "Solve equations that use variables to represent unknown numbers",
          descriptors: [
            "Can they use their understanding of operations to solve situations where they are multiple unknowns?",
          ],
        },
        ext: {
          title:
            "(Level 4) Solve two-step multiplication and division word problems with variables (all four operations)",
          descriptors: [
            "Can they solve a two-step multiplication or division word problem?",
            "Can they solve an equation that includes all four operations and uses a variable to represent an unknown number?",
          ],
        },
      },
      {
        q: {
          title: "Identify and complete a pattern of rotation",
          descriptors: ["Can they explain and continue a pattern of rotation?"],
        },
        ext: {
          title: "(Level 4) Generate patterns from given rules or from a table",
          descriptors: [
            "Given a table with an addition or subtraction pattern, can they identify and explain the pattern?",
          ],
        },
      },
      {
        q: {
          title: "Make a key to classify 2D shapes",
          descriptors: [
            "Can they explain 3 different ways to classify the same group 2D shapes?",
          ],
        },
        ext: {
          title:
            "(Level 4) Use hierarchy organization to classify triangle types and quadrilaterals by attributes",
          descriptors: [
            "Can they place given objects in such a way that the relationships of a given tree diagram hold true?",
          ],
        },
      },
    ],
    4: [
      {
        q: {
          title:
            "Solve two-step multiplication and division word problems with variables (all four operations)",
          descriptors: [
            "Can they solve a two-step multiplication or division word problem?",
            "Can they solve an equation that includes all four operations and uses a variable to represent an unknown number?",
          ],
        },
        ext: {
          title:
            "(Level 5) Solve mathematical problems by creating algebraic expressions",
          descriptors: [
            "Given a word problem, can they create an algebraic equation and solve it?",
          ],
        },
      },
      {
        q: {
          title: "Generate patterns from given rules or from a table",
          descriptors: [
            "Given a table with an addition or subtraction pattern, can they identify the pattern?",
          ],
        },
        ext: {
          title: "(Level 5) Identify patterns of numbers from a table",
          descriptors: [
            "Given a table with a multiplication or division pattern, can they identify the pattern?",
          ],
        },
      },
      {
        q: {
          title:
            "Use hierarchy organization to classify triangle types and quadrilaterals by attributes",
          descriptors: [
            "Can they place given objects in such a way that the relationships of a given tree diagram hold true?",
          ],
        },
        ext: {
          title:
            "(Level 5) Determine types of polygons with classification cards",
          descriptors: [
            "Can they use classification to determine the defining attributes of given shapes?",
          ],
        },
      },
    ],
    5: [
      {
        q: {
          title:
            "Solve mathematical problems by creating algebraic expressions",
          descriptors: [
            "Given a word problem, can they create an algebraic equation and solve it?",
          ],
        },
      },
      {
        q: {
          title: "Identify patterns of numbers from a table",
          descriptors: [
            "Given a table with a multiplication or division pattern, can they identify the pattern?",
          ],
        },
      },
      {
        q: {
          title: "Determine types of polygons with classification cards",
          descriptors: [
            "Can they use classification to determine the defining attributes of given shapes?",
          ],
        },
      },
    ],
  },
  geometry: {
    1: [
      {
        q: {
          title:
            "Identify and compare basic geometric shapes, regardless of orientation or size. (Triangles, circles, squares, rectangles)",
          descriptors: [
            "Can they identify a triangle, circle, square, and rectangle given a chaotic spread of shapes?",
          ],
        },
        ext: {
          title:
            "(Level 2) Identify and compare 2D geometric shapes based on their attributes, regardless of orientation or size. (Rhombus, parallelogram, hexagon, octagon, cone, sphere, cube, cylinder) (Attributes- number of sides and number of corners, side lengths)",
          descriptors: [
            "Can they identify a rhombus, parallelogram, hexagon, octagon, cone, sphere, cube, and a cylinder, given a chaotic spread of shapes?",
          ],
        },
      },
      {
        q: {
          title: "Determine which object is the same or different in a set.",
          descriptors: [
            "Given a set of objects, can they find a pair that is the same? ",
            "Given a set of objects, can they pick out the one that is different?",
          ],
        },
        ext: {
          title: "(Level 2) Copy a given figure in a provided space.",
          descriptors: ["Given a figure, can they copy it onto a whiteboard?"],
        },
      },
    ],
    2: [
      {
        q: {
          title:
            "Identify and compare 2D geometric shapes based on their attributes, regardless of orientation or size. (Rhombus, parallelogram, hexagon, octagon, cone, sphere, cube, cylinder) (Attributes- number of sides and number of corners, side lengths)",
          descriptors: [
            "Can they identify a rhombus, parallelogram, hexagon, octagon, cone, sphere, cube, and a cylinder, given a chaotic spread of shapes?",
          ],
        },
        ext: {
          title: "(Level 3) Identify points, lines, line segments, and rays.",
          descriptors: [
            "Can they match points, lines, line segments, and rays to their definitions given a set of cards?",
          ],
        },
      },
      {
        q: {
          title: "Copy a given figure in a provided space.",
          descriptors: ["Given a figure, can they copy it onto a whiteboard?"],
        },
        ext: {
          title: "(Level 3) Identify congruent shapes.",
          descriptors: [
            "Given a mix of shapes, can they match congruent shapes?",
          ],
        },
      },
    ],
    3: [
      {
        q: {
          title: "Identify points, lines, line segments, and rays.",
          descriptors: [
            "Can they match points, lines, line segments, and rays to their definitions given a set of cards?",
          ],
        },
        ext: {
          title:
            "(Level 4) Classify 2D and 3D figures based on the basic properties of shapes. (Quadrilaterals, polygons, and types of triangles) (measures of angles) ",
          descriptors: [
            "Can they match quadrilaterals to their definitions given quadrilateral cards?",
          ],
        },
      },
      {
        q: {
          title: "Identify congruent shapes.",
          descriptors: [
            "Given a mix of shapes, can they match congruent shapes?",
          ],
        },
        ext: {
          title:
            "(Level 4) Determine if given figures are similar in terms of transformations where angle measure is preserved and side length changes proportionally.",
          descriptors: [
            "Given two figures, can they prove that they are similar by looking at their sides and angles?",
          ],
        },
      },
    ],
    4: [
      {
        q: {
          title:
            "Classify 2D and 3D figures based on the basic properties of shapes. " +
            "(Quadrilaterals, polygons, and types of triangles) (measures of angles)",
          descriptors: [
            "Can they match quadrilaterals to their definitions given quadrilateral cards?",
          ],
        },
        ext: {
          title:
            "(Level 5) Classify polyhedrons based on common attributes. (pyramid, prism, platonic solids) (attributes- flat polygon faces, pyramids-bases, platonic solids-all faces are identical regular polygons) AND Examine and identify geometric nets and their properties. (using shapes already out)",
          descriptors: [
            "Can they match three dimensional shapes with their geometrical net given many different nets including ones that do not create that shape?",
          ],
        },
      },
      {
        q: {
          title:
            "Determine if given figures are similar in terms of transformations where angle measure is preserved and side length changes proportionally.",
          descriptors: [
            "Given two figures, can they prove that they are similar by looking at their sides and angles?",
          ],
        },
        ext: {
          title: "(Level 5) Identify similar triangles.",
          descriptors: [
            "Given multiple triangles, can they pick out the ones that are similar?",
          ],
        },
      },
    ],
    5: [
      {
        q: {
          title:
            "Classify polyhedrons based on common attributes. (pyramid, prism, platonic solids) (attributes- flat polygon faces, pyramids-bases, platonic solids-all faces are identical regular polygons) AND Examine and identify geometric nets and their properties. (using shapes already out)",
          descriptors: [
            "Can they match three dimensional shapes with their geometrical net given many different nets including ones that do not create that shape?",
          ],
        },
      },
      {
        q: {
          title: "Identify similar triangles.",
          descriptors: [
            "Given multiple triangles, can they pick out the ones that are similar?",
          ],
        },
      },
    ],
  },
  measurement: {
    1: [
      {
        q: {
          title: "Morning/Night",
          descriptors: [
            "Can they tell you if an activity would occur in the morning or at night?",
          ],
        },
        ext: {
          title: "(Level 2) Hour, AM PM",
          descriptors: [
            "Can they identify time by the hour?",
            "Can they tell you if an acitivy occurs in the AM or PM?",
          ],
        },
      },
      {
        q: {
          title:
            "Visually distinguish between items based on measurable criteria.",
          descriptors: [
            "Can they compare two objects and tell you which is longer?",
          ],
        },
        ext: {
          title: "(Level 2) Measure and compare length in nonstandard units.",
          descriptors: [
            "Can they compare two objects using a nonstandard unit of measurement (i.e. paperclips) to determine which object is longer?",
          ],
        },
      },
    ],
    2: [
      {
        q: {
          title: "Hour, AM PM",
          descriptors: [
            "Can they identify time by the hour?",
            "Can they tell you if an activity occurs in the AM or PM?",
          ],
        },
        ext: {
          title: "(Level 3) Half hour, Quarter, Five min, Military",
          descriptors: [
            "Can they identify the time by the half hour?",
            "Can they identify time by quarters or five minute increments?",
          ],
        },
      },
      {
        q: {
          title: "Measure and compare length in nonstandard units.",
          descriptors: [
            "Can they compare two objects using a nonstandard unit of measurement (i.e. paperclips) to determine which object is longer?",
          ],
        },
        ext: {
          title:
            "(Level 3) Measure and compare objects in standard units. (length in cm and inches, estimation of length, units of measurement and which is most appropriate to use for each attribute, time comparisons, weight, capacity in cups and cylinders, inch or foot for football field, different units will give different measurements of the same object)",
          descriptors: [
            "Can they explain why some units are more appropriate than others to measure given objects?",
          ],
        },
      },
    ],
    3: [
      {
        q: {
          title: "Half hour, Quarter, Five min, Military",
          descriptors: [
            "Can they identify the time by the half hour?",
            "Can they identify time by quarters or five minute increments?",
          ],
        },
        ext: {
          title: "(Level 4) Add and subtract intervals of time ",
          descriptors: [
            "Can they add intervals of time?",
            "Can they subtract intervals of time?",
          ],
        },
      },
      {
        q: {
          title:
            "Measure and compare objects in standard units. (length in cm and inches, estimation of length, units of measurement and which is most appropriate to use for each attribute, time comparisons, weight, capacity in cups and cylinders, inch or foot for football field, different units will give different measurements of the same object)",
          descriptors: [
            "Can they explain why some units are more appropriate than others to measure given objects?",
          ],
        },
        ext: {
          title:
            "(Level 4) Measure and compare objects in standard units. (appropriate units based on knowledge of it, how to measure length with fractional increments for comparison)",
          descriptors: [
            "Can they use standard units to measure and compare two objects?",
          ],
        },
      },
    ],
    4: [
      {
        q: {
          title: "Add and subtract intervals of time",
          descriptors: [
            "Can they add intervals of time?",
            "Can they subtract intervals of time?",
          ],
        },
        ext: {
          title: "(Level 5) Elapsed Time",
          descriptors: ["Can they calculate the elapsed time?"],
        },
      },
      {
        q: {
          title:
            "Measure and compare objects in standard units. (appropriate units based on knowledge of it, how to measure length with fractional increments for comparison)",
          descriptors: [
            "Can they use standard units to measure and compare two objects?",
          ],
        },
        ext: {
          title:
            "(Level 5) Convert measurement data between measurement systems. (relationship between units that are converted, calculations to convert?, application of doing the conversion aka ratio understanding, explain why the value of the measure isn't changing only the unit, relationship between metric and US units in length and volume)",
          descriptors: [
            "Can they convert measurements using ratios?",
            "Can they explain what is and is not changing when converting between units?",
          ],
        },
      },
    ],
    5: [
      {
        q: {
          title: "Elapsed Time",
          descriptors: [
            "Can they add intervals of time?",
            "Can they subtract intervals of time?",
          ],
        },
      },
      {
        q: {
          title:
            "Convert measurement data between measurement systems. (relationship between units that are converted, calculations to convert?, application of doing the conversion aka ratio understanding, explain why the value of the measure isn't changing only the unit, relationship between metric and US units in length and volume)",
          descriptors: [
            "Can they convert measurements using ratios?",
            "Can they explain what is and is not changing when converting between units?",
          ],
        },
      },
    ],
  },
  dap: {
    1: [
      {
        q: {
          title:
            "Given chaotic data, organize it in two different ways and compare the counts of different arrangements of the same data set.",
          descriptors: [
            "Given random items, can they organize them and compare the counts of each group they created?",
          ],
        },
        ext: {
          title:
            "(Level 2) Organize, represent, and interpret data with up to three categories, where some data points belong to more than one category.",
          descriptors: [
            "Given random items, can they organize them into three given categories where some items will belong to multiple categories?",
            "Can they answer questions about these categories such as, (does this item belong to just one category? Why or why not)?",
          ],
        },
      },
    ],
    2: [
      {
        q: {
          title:
            "Organize, represent, and interpret data with up to three categories, where some data points belong to more than one category.",
          descriptors: [
            "Given random items, can they organize them into three given categories where some items will belong to multiple categories?",
            "Can they answer questions about these categories such as, (does this item belong to just one category?",
            "Why or why not)?",
          ],
        },
        ext: {
          title:
            "(Level 3) Given chaotic data, construct a bar graph and compare data sets by answering quantitative data questions such as, (How many more ___ are there than ___)?",
          descriptors: [
            "Can they create a bar graph given random items and answer questions such as (how many more ___ are there than ___)?",
          ],
        },
      },
    ],
    3: [
      {
        q: {
          title:
            "Given chaotic data, construct a bar graph and compare data sets by answering quantitative data questions such as, " +
            "(How many more ___ are there than ___?)",
          descriptors: [
            "Can they create a bar graph given random items and answer questions such as (how many more ___ are there than ___)?",
          ],
        },
        ext: {
          title:
            "(Level 4) Given two different graphical representations of the same data set to answer compare and contrast questions such as, (which graph represents the data better?) graph influencing the way you see the data.",
          descriptors: [
            "Given two different graphs depicting the same data, can they answer questions such as (which graph best represents this data)?",
          ],
        },
      },
    ],
    4: [
      {
        q: {
          title:
            "Given two different graphical representations of the same data set to answer compare and contrast questions such as, (which graph represents the data better?) graph influencing the way you see the data.",
          descriptors: [
            "Given two different graphs depicting the same data, can they answer questions such as (which graph best represents this data)?",
          ],
        },
        ext: {
          title:
            "Given different data sets (one maybe including decimals and fractions) link the data sets to given graphs (one may be a pie chart).",
          descriptors: [
            "Given a set of cards that includes data sets and graphs, can they correctly match the data set to the corresponding graph.",
          ],
        },
      },
    ],
    5: [
      {
        q: {
          title:
            "Given different data sets (one maybe including decimals and fractions) link the data sets to given graphs (one may be a pie chart).",
          descriptors: [
            "Given a set of cards that includes data sets and graphs, can they correctly match the data set to the corresponding graph.",
          ],
        },
      },
    ],
  },
};

export { quizContent };
